import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';

@observer
class CalendarTemplateList extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    loadAll = async () => {
        const { calendarTemplateStore } = this.props.stores;
        await calendarTemplateStore.load({ query: {} });
    }

    openNew = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightMedium } = appState;

        appState.openDrawer('newCalendarTemplate', {
            height: drawerHeightMedium,
            isNew: true,
            callback: () => {
                appState.toggleDrawer(false, drawerLevel + 1);
                this.loadAll();
            },
        }, drawerLevel + 1);
    }

    openEdit = (e) => {
        const { id } = e.target.closest('.template-item').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightMedium } = appState;

        appState.openDrawer('editCalendarTemplate', {
            height: drawerHeightMedium,
            isNew: false,
            id: parseInt(id, 10),
            callback: () => {
                appState.toggleDrawer(false, drawerLevel + 1);
                this.loadAll();
            },
        }, drawerLevel + 1);
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { drawerLevel } = this.props;
        const { userStore, calendarTemplateStore } = this.props.stores;
        const { user, isAdmin, isCustomerAdmin } = userStore;
        const { calendarTemplates } = calendarTemplateStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        const canManage = isAdmin || isCustomerAdmin;

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='d-flex flex-row justify-content-between align-items-center px-3 mb-3'>
                        <div class='font-weight-lighter box-header mt-0'>
                            <Text id='calendarTemplate.list'>Calendar Templates</Text>
                        </div>
                        {canManage && <>
                            <button type='button' class='btn btn-success btn-sm rounded-pill' onClick={this.openNew}>
                                <i class='fa-solid fa-plus me-2' />
                                <Text id='calendarTemplate.addNew'>New Template</Text>
                            </button>
                        </>}
                    </div>

                    {!canManage && <>
                        <div class='alert alert-warning mx-3'>
                            <Text id='calendarTemplate.noPermission'>Only customer admins can manage calendar templates.</Text>
                        </div>
                    </>}

                    {calendarTemplates?.length === 0 && canManage && <>
                        <div class='alert alert-info mx-3'>
                            <Text id='calendarTemplate.empty'>No templates yet. Click "New Template" to create one.</Text>
                        </div>
                    </>}

                    <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-3 d-flex flex-column rounded-lg overflow-hidden`}>
                        {calendarTemplates?.map((template, idx) => {
                            const bgColor = template.backgroundColor || '#e9ecef';
                            const textColor = template.color || '#333';
                            return (
                                <div
                                    class={`template-item d-flex flex-row justify-content-between align-items-center py-3 px-3 ${idx > 0 ? 'border-top' : ''}`}
                                    style='cursor: pointer;'
                                    data-id={template.id}
                                    onClick={canManage ? this.openEdit : null}
                                >
                                    <div class='d-flex align-items-center'>
                                        <div
                                            class='py-1 px-3 rounded-pill me-3'
                                            style={`background-color: ${bgColor}; color: ${textColor}; min-width: 120px; text-align: center;`}
                                        >
                                            {template.name}
                                        </div>
                                        <div class='d-flex flex-column'>
                                            <span class='text-muted small'>
                                                {template.durationMinutes || 30} min
                                                {template.title && <> - {template.title}</>}
                                            </span>
                                            {template.body && <>
                                                <span class='text-muted small' style='max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'>
                                                    {template.body}
                                                </span>
                                            </>}
                                        </div>
                                    </div>
                                    {canManage && <>
                                        <div>
                                            <i class='fa-solid fa-chevron-right text-muted' />
                                        </div>
                                    </>}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>);
    }
}

export default CalendarTemplateList;
